import React from "react";
import { Alert, Box, Typography } from "@mui/joy";

export function CanvasViewGridPlaceholder({
  title,
  message,
  color = "neutral",
}: {
  title?: string;
  message: string;
  color?: "neutral" | "warning" | "danger";
}) {
  return (
    <Alert
      color={color}
      variant="soft"
      sx={{
        height: "100%",
        minHeight: 120,
        alignItems: "center",
      }}
    >
      <Box>
        <Typography level="title-sm">{title || "View Grid"}</Typography>
        <Typography level="body-sm">{message}</Typography>
      </Box>
    </Alert>
  );
}

export default CanvasViewGridPlaceholder;
